import rtStreamApi from "@/api/machineRealtimeApi";

const streamApi = rtStreamApi;

export default streamApi;
